import React from 'react'
import { Link } from "gatsby";
import logo from "../../../images/Jersey-Met-Premium-Services-Logo.svg"
import "../Sidebar.scss";
import { makeStyles, } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    "&:hover": {
      color: "#b60011",   
    },
    "&:focus": {
    backgroundColor: "hsl(208, 89%, 34%)",
    color: "#fff"
    }
  },
}));

const PremiumServices = () => {
    const hoverStyle = useStyles()
    return (
    <aside id="sideBar" >
    <div id="navigator">

    <div className="sidePanel">
        <div style={{ backgroundImage:`url(${logo})`, height:'100px', backgroundRepeat: 'no-repeat',backgroundPosition: '-5px' }}></div>
        {/* <img alt="Premium services" src={logo} ></img> */}
        <h1>Premium Services</h1>    
        <p>Talk to a forecaster on<br />T&nbsp;&nbsp;&nbsp;<a className={hoverStyle.root} href="tel:+4490580777774">0905 807 7777</a><br />Calls charged at £1.50 per minute</p>
        <p><Link className={hoverStyle.root} activeClassName="" to='/services' >View all premium weather services</Link></p>
     </div>

     </div>
     </aside>
    )
}

export default PremiumServices